import { Box, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { IconBadge } from "./icon-badge";

function MeetingDetailItem({
  icon,
  primary,
  secondary,
}: {
  icon: React.ReactNode;
  primary: React.ReactNode;
  secondary?: React.ReactNode;
}) {
  return (
    <ListItem
      alignItems="flex-start"
      sx={{
        px: 2,
        py: 1.25,
        gap: 1.5,
      }}
    >
      <ListItemIcon sx={{ minWidth: 0, mt: 0.25 }}>
        <IconBadge>{icon}</IconBadge>
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography
            component="div"
            fontSize={11}
            fontWeight={700}
            color="#94A3B8"
            letterSpacing={0.6}
            textTransform="uppercase"
            mb={0.375}
          >
            {primary}
          </Typography>
        }
        secondary={
          <Box component="span" display="block">
            {secondary}
          </Box>
        }
        sx={{ my: 0 }}
      />
    </ListItem>
  );
}

export { MeetingDetailItem };
